<template>
  <div>
    <div :class="className" ref="oneecharts" :style="{ height: height, width: width }" />
  </div>
</template>

<script>
import * as echarts from 'echarts'

require('echarts/theme/macarons') // echarts theme
import resize from './mixins/resize'

const animationDuration = 2000

export default {
  mixins: [resize],
  props: {
    className: {
      type: String,
      default: 'chart'
    },
    name: {
      type: String,
      default: ''
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '300px'
    },
    autoResize: {
      type: Boolean,
      default: true
    },
    chartData: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      // 是否显示弹出层
      cxzbopen: false,
      chart: null,
      data: null,
      yuzhiList: [], // 初始化yuzhiList为空数组
      min: 0,
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart()
    })

    if (this.chartData == null) {
      //临时数据
      let frontOneHour = new Date(new Date().getTime());
      frontOneHour = this.$xUtil.parseTime(frontOneHour, '{h}:{i}');
      let frontOneHour_2 = new Date(new Date().getTime() - 2 * 60 * 60 * 1000);
      frontOneHour_2 = this.$xUtil.parseTime(frontOneHour_2, '{h}:{i}');
      let frontOneHour_4 = new Date(new Date().getTime() - 4 * 60 * 60 * 1000);
      frontOneHour_4 = this.$xUtil.parseTime(frontOneHour_4, '{h}:{i}');
      let frontOneHour_6 = new Date(new Date().getTime() - 6 * 60 * 60 * 1000);
      frontOneHour_6 = this.$xUtil.parseTime(frontOneHour_6, '{h}:{i}');
      let frontOneHour_8 = new Date(new Date().getTime() - 8 * 60 * 60 * 1000);
      frontOneHour_8 = this.$xUtil.parseTime(frontOneHour_8, '{h}:{i}');

      let keys = [frontOneHour_8, frontOneHour_6, frontOneHour_4, frontOneHour_2, frontOneHour];
      this.data = {
        xAxisData: keys,
        seriesData: [10, 10.1, 10.5, 11, 10.4],
        yuzhiList: [] // 初始化yuzhiList为空数组
      }
    } else {
      this.data = this.chartData;
      // 确保yuzhiList是数组
      if (!Array.isArray(this.data.yuzhiList)) {
        this.data.yuzhiList = this.data.yuzhiList || [];
      }
    }

    // 检查yuzhiList是否存在且为数组
    if (Array.isArray(this.data.yuzhiList)) {
      if (this.data.yuzhiList.length === 0) {
        // 警戒和超保证
        if (this.chartData.jingjie != null || this.chartData.chaobaozheng != null) {
          if (this.chartData.jingjie != null) {
            this.data.yuzhiList.push({
              "text": "警戒",
              "value": this.chartData.jingjie,
              "symbol": "<",
              "color": "#e9fa00"
            });
          }
          if (this.chartData.chaobaozheng != null) {
            this.data.yuzhiList.push({
              "text": "超保证",
              "value": this.chartData.chaobaozheng,
              "symbol": ">",
              "color": "#ff0000"
            });
          }
        }
        
        // 轻旱
        if (this.chartData.qinghan != null) {
          this.data.yuzhiList.push({
            "text": "轻旱",
            "value": this.chartData.qinghan,
            "symbol": "<",
            "color": "#ffff00"
          });
        }
        // 中旱
        if (this.chartData.zhonghan != null) {
          this.data.yuzhiList.push({
            "text": "中旱",
            "value": this.chartData.zhonghan,
            "symbol": "<",
            "color": "#ffaa00"
          });
        }
        // 重旱
        if (this.chartData.zhongzhonghan != null) {
          this.data.yuzhiList.push({
            "text": "重旱",
            "value": this.chartData.zhongzhonghan,
            "symbol": "<",
            "color": "#ff5500"
          });
        }
        // 特旱
        if (this.chartData.tehan != null) {
          this.data.yuzhiList.push({
            "text": "特旱",
            "value": this.chartData.tehan,
            "symbol": "<",
            "color": "#FF0000"
          });
        }

        // 渠顶高程
        if (this.chartData.qudingshuiwei != null) {
          this.data.yuzhiList.push({
            "text": "渠顶高程",
            "value": this.chartData.qudingshuiwei,
            "symbol": ">",
            "color": "#ff0000"
          });
        }
        // 池顶高度
        if (this.chartData.chidinggaocheng != null) {
          this.data.yuzhiList.push({
            "text": "池顶高度",
            "value": this.chartData.chidinggaocheng,
            "symbol": ">",
            "color": "#ff0000"
          });
        }

        // 启泵水位
        if (this.chartData.qibengshuiwei != null) {
          this.data.yuzhiList.push({
            "text": "启泵水位",
            "value": this.chartData.qibengshuiwei,
            "symbol": ">",
            "color": "#ff0000"
          });
        }
      }
    }
    console.log(this.data, "===========================")
  },
  beforeDestroy() {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  },
  methods: {
    handleClickcxzb() {
      this.cxzbopen = false
      this.$emit('on-point')
    },
    fangdaecharts() {
      this.cxzbopen = true
      this.inittanchuangChart()
      console.log(this.cxzbopen)
    },
    initChart() {
      this.chart = echarts.init(this.$refs.oneecharts, 'shine')
      const seriesData = [...this.data.seriesData];

      // 确保yuzhiList是数组后再迭代
      if (Array.isArray(this.data.yuzhiList)) {
        for (const item of this.data.yuzhiList) {
          seriesData.push(item.value);
        }
      }

      const chumin = Math.min(...seriesData) - 0.5;
      const max = Math.max(...seriesData) + 0.5;

      this.min = chumin;

      this.chart.setOption({
        tooltip: {
          trigger: 'axis'
        },
        grid: {
          top: '23%',
          left: '10%',
          right: '10%',
          bottom: '2%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: false, //坐标轴两边留白
          data: this.data.xAxisData,
          axisLabel: { //坐标轴刻度标签的相关设置。
            textStyle: {
              color: '#eeeeee',
              fontStyle: 'normal',
              fontFamily: '微软雅黑',
              fontSize: 12,
            },
          },
          axisTick: { //坐标轴刻度相关设置。
            show: false,
          },
          axisLine: { //坐标轴轴线相关设置
            lineStyle: {
              color: '#CAFFFD',
              opacity: 0.3
            }
          },
          splitLine: { //坐标轴在 grid 区域中的分隔线。
            show: false,
            lineStyle: {
              color: '#E5E9ED',
            }
          }
        },
        yAxis: [{
          min: this.min.toFixed(2),
          max: max.toFixed(2),
          type: 'value',
          name: '单位:(' + this.data.danwei + ')',
          axisLabel: {
            textStyle: {
              color: '#EEEEEE',
              fontStyle: 'normal',
              fontFamily: '微软雅黑',
              fontSize: 12,
            }
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: '#ffffff',
              opacity: 0.3
            }
          },
          axisTick: {
            show: false
          },
          splitLine: {
            show: true,
            lineStyle: {
              type: 'dashed',
              color: 'rgba(202, 255, 253, 0.2)',
            }
          }

        }],
        series: [{
          type: 'line',
          smooth: true,
          symbol: 'circle',
          symbolSize: 5,
          itemStyle: {
            normal: {
              color: 'rgba(32, 248, 134, 1)',
              shadowColor: '#20F886',
              shadowBlur: 10,
              borderColor: '#20F886',
              borderWidth: 2,
              lineStyle: {
                color: "#20F886",
                width: 1
              },
              areaStyle: {
                color: new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [{
                  offset: 0,
                  color: 'rgba(0,0,0,0)'
                }, {
                  offset: 1,
                  color: 'rgba(32, 248, 134, 1)'
                }]),
              }
            }
          },
          data: this.data.seriesData,
          markLine: {
            symbol: ['none'],
            data: Array.isArray(this.data.yuzhiList) ? this.data.yuzhiList.map(item => {
              const color = item.color || "#00ff00";
              const value = item.value;
              const text = item.text || "";
              return {
                silent: true,
                lineStyle: {
                  type: "solid",
                  color: color,
                },
                label: {
                  position: "top",
                  show: false,
                  formatter: `{a|${value}}  {b|${text}}`,
                  rich: {
                    a: {
                      color: '#fff',
                      fontSize: 15,
                    },
                    b: {
                      color: '#fff',
                      fontSize: 15,
                      width: '100%',
                      align: 'center',
                      overflow: 'truncate',
                      padding: [0, 5],
                    },
                  },
                },
                yAxis: value,
                emphasis: {
                  label: {
                    show: true,
                    position: "top",
                    textStyle: {
                      color: '#fff',
                      fontSize: 15,
                    }
                  }
                }
              };
            }) : [],
          },
        }],
      })
    }
  }
}
</script>

<style>
.el-dialog-cxzb .el-dialog {
  position: relative;
  margin: 0 auto 50px;
  background: #154981 !important;
  margin-top: 0vh !important;
  margin-left: 22.3% !important;
  width: 56% !important;
  height: 82% !important;
}

.el-dialog-cxzb .x-close {
  width: 50px;
  height: 50px;
  position: absolute;
  right: 30px;
  cursor: pointer;
}

.el-dialog-cxzb .el-dialog__headerbtn .el-dialog__close {
  color: #ffffff;
  font-size: 30px;
}

.el-dialog-cxzb .el-dialog__body {
  padding: 0px 0px;
  color: #606266;
  width: 100%;
  height: 94%;
}

.el-dialog-cxzb .el-dialog__mask {
  background-color: transparent;
}

.titlecss {
  text-align: center;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
</style>